import { render, staticRenderFns } from "./wxBill.vue?vue&type=template&id=9d550bd8&scoped=true&"
import script from "./wxBill.vue?vue&type=script&lang=js&"
export * from "./wxBill.vue?vue&type=script&lang=js&"
import style0 from "./wxBill.vue?vue&type=style&index=0&id=9d550bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d550bd8",
  null
  
)

export default component.exports